module.exports = __webpack_public_path__ + "img/glades_yes-OM1iR6C.svg";